/**
 * Heading Accent System — long-text padding
 * Adds .accent--long when accent text length ≥ 10 (spaces included).
 * Keep in sync with firmhouse-templates/shared_head.liquid.
 */
(function () {
  var LONG_CLASS = 'accent--long';
  var THRESHOLD = 10;

  function accentTextLength(el) {
    return (el.textContent || '').length;
  }

  function syncAccent(el) {
    if (!el || !el.classList || !el.classList.contains('accent')) return;
    if (accentTextLength(el) >= THRESHOLD) {
      el.classList.add(LONG_CLASS);
    } else {
      el.classList.remove(LONG_CLASS);
    }
  }

  function syncAll(root) {
    var scope = root && root.nodeType === 1 ? root : document;
    if (scope.classList && scope.classList.contains('accent')) {
      syncAccent(scope);
    }
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('.accent') : [];
    for (var i = 0; i < nodes.length; i++) {
      syncAccent(nodes[i]);
    }
  }

  function closestAccent(node) {
    var el = node && node.nodeType === 3 ? node.parentElement : node;
    while (el && el !== document.documentElement) {
      if (el.classList && el.classList.contains('accent')) return el;
      el = el.parentElement;
    }
    return null;
  }

  function boot() {
    syncAll(document);

    if (window.__bzHeadingAccentsBound) return;
    window.__bzHeadingAccentsBound = true;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'characterData') {
          var accent = closestAccent(mutation.target);
          if (accent) syncAccent(accent);
          continue;
        }

        if (mutation.type === 'childList') {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (!node || node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('accent')) {
              syncAccent(node);
            }
            if (node.querySelectorAll) {
              syncAll(node);
            }
          }

          if (mutation.target && mutation.target.classList && mutation.target.classList.contains('accent')) {
            syncAccent(mutation.target);
          }
        }
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  window.bzSyncHeadingAccents = syncAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
